// Snippets
import baseSnippetSchema from './snippet_schema.json';

// Rules
import baseRulesSchema from './rules_schema.json';

// Data
import callCentreTimes from './call_centre_times.json';

// Components
import header from './component/header.json';
import footer from './component/footer.json';
import generic from './component/generic.json';
import modals from './component/modals.json';
import pleaseWait from './component/please_wait.json';

// Layout utils
import containerFullWidth from './layout/utils/container_full_width.json';
import containerCentered from './layout/utils/container_centered.json';
import row from './layout/utils/row.json';
import block from './layout/utils/block.json';

// Layout elements
import headerLayout from './layout/header.json';
import footerLayout from './layout/footer.json';
import bodyGeneric from './layout/body_generic.json';
import bodyJourney from './layout/body_journey.json';
import menuBar from './layout/menu_bar.json';
import modalContainer from './layout/modal_container.json';

const baseComponentSchema = {
    ...header,
    ...footer,
    ...generic,
    ...modals,
    ...pleaseWait
};

const baseLayoutElementsSchema = {
    ...containerFullWidth,
    ...containerCentered,
    ...row,
    ...block,
    ...headerLayout,
    ...footerLayout,
    ...bodyGeneric,
    ...bodyJourney,
    ...menuBar,
    ...modalContainer
};

export {
    baseSnippetSchema,
    baseRulesSchema,
    callCentreTimes,
    baseComponentSchema,
    baseLayoutElementsSchema
};
